import React, { Ref, RefObject, useEffect, useRef, useState } from 'react';

export default function useIsOverflow(ref: RefObject<HTMLElement | undefined>) {
  const [isOverflow, setIsOverflow] = React.useState<boolean>();

  React.useLayoutEffect(() => {
    if (ref.current) {
      const hasOverflow = ref.current.scrollHeight > ref.current.clientHeight;

      setIsOverflow(hasOverflow);
    }
  }, [ref]);
  return isOverflow;
}

// export function useOverflowTooltip(message: string) {
//   const ref = useRef<HTMLElement>(null);

//   React.useLayoutEffect(() => {
//     if (ref.current) {
//       const hasOverflow = ref.current.scrollHeight > ref.current.clientHeight;

//       if (hasOverflow && message) {
//         ref.current.setAttribute('data-aoa-tooltip', message);
//       } else {
//         ref.current.removeAttribute('data-aoa-tooltip');
//       }
//     }
//   }, [ref.current]);

//   return ref;
// }
